import { mapStageToEnvironment } from '@zep/feature-flag';

export const FEATURE_FLAG_SERVER_URL =
  process.env.NEXT_PUBLIC_FEATURE_FLAG_URL ?? '';
export const FEATURE_FLAG_NAMESPACE = 'quiz';
export const FEATURE_FLAG_ENVIRONMENT = mapStageToEnvironment(
  process.env.NEXT_PUBLIC_STAGE,
);
